"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9507,5566],{

/***/ 81551:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _workspace_educative_yarn_virtual_next_virtual_1bd058a2ed_0_cache_next_patch_6b35a1a9ef_6d04a71070_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54551);
/* harmony import */ var _workspace_educative_yarn_virtual_next_virtual_1bd058a2ed_0_cache_next_patch_6b35a1a9ef_6d04a71070_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_workspace_educative_yarn_virtual_next_virtual_1bd058a2ed_0_cache_next_patch_6b35a1a9ef_6d04a71070_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66729);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59914);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72176);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88825);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83249);
/* harmony import */ var components_DashboardPages_Workflow_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23445);
/* harmony import */ var components_Header__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46452);
/* harmony import */ var components_SideBar__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7279);
/* harmony import */ var constants_index__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71653);
/* harmony import */ var context_UserInfoProvider__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(56980);
/* harmony import */ var utils_environments__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(35239);
/* harmony import */ var utils_pageUtils__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(18645);
/* harmony import */ var utils_sentry__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(31414);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}














var Container = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 38725).then(__webpack_require__.bind(__webpack_require__, 38725));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(38725)
            ];
        }
    }
});
var ErrorPage = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 84310).then(__webpack_require__.bind(__webpack_require__, 84310));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84310)
            ];
        }
    }
});
var WorkflowErrorPage = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(64427), __webpack_require__.e(12974)]).then(__webpack_require__.bind(__webpack_require__, 64427));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(64427)
            ];
        }
    }
});
var MyError = function(_param) {
    var statusCode = _param.statusCode, hasGetInitialPropsRun = _param.hasGetInitialPropsRun, err = _param.err, props = _objectWithoutProperties(_param, [
        "statusCode",
        "hasGetInitialPropsRun",
        "err"
    ]);
    var ref;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var userInfoState = (0,react__WEBPACK_IMPORTED_MODULE_5__.useContext)(context_UserInfoProvider__WEBPACK_IMPORTED_MODULE_10__/* .storeUserInfo */ .wr).userInfoState;
    var userInfo = userInfoState === null || userInfoState === void 0 ? void 0 : userInfoState.data;
    var isWorkflowEnabled = userInfo === null || userInfo === void 0 ? void 0 : (ref = userInfo.enterprise) === null || ref === void 0 ? void 0 : ref.is_workflow_enabled;
    var isWorkflowPage = components_DashboardPages_Workflow_constants__WEBPACK_IMPORTED_MODULE_6__/* .VALID_WORKFLOW_URLS.Workflows.test */ .y$.Workflows.test(router.asPath) && isWorkflowEnabled;
    if (!hasGetInitialPropsRun && err) {
        // Workaround of https://github.com/vercel/next.js/issues/8592
        var extraErrorParams = _objectSpread(_defineProperty({}, constants_index__WEBPACK_IMPORTED_MODULE_9__/* .SENTRY_EVENT_EXTRA_PARAMS.pageBroken */ .jMz.pageBroken, "true"), isWorkflowPage && _defineProperty({}, constants_index__WEBPACK_IMPORTED_MODULE_9__/* .SENTRY_EVENT_EXTRA_PARAMS.workflowPageBroken */ .jMz.workflowPageBroken, "true"));
        var errorInfo = _objectSpread({}, extraErrorParams, isWorkflowPage && statusCode && {
            statusCode: String(statusCode)
        });
        (0,utils_sentry__WEBPACK_IMPORTED_MODULE_12__/* .sendErrorEvent */ .uX)(err, errorInfo, {}, extraErrorParams);
    }
    if (isWorkflowPage) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            className: "ed-grid",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "ed-grid-main",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WorkflowErrorPage, {
                    flagCode: statusCode === null || statusCode === void 0 ? void 0 : statusCode.toString()
                })
            })
        });
    }
    if (statusCode === 404) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: "ed-grid",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_SideBar__WEBPACK_IMPORTED_MODULE_8__["default"], {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Header__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "ed-grid-main ".concat(utils_pageUtils__WEBPACK_IMPORTED_MODULE_13__/* .landingPageClasses */ .k0),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Container, _objectSpread({}, props), "*")
            })
        ]
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: "ed-grid",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_SideBar__WEBPACK_IMPORTED_MODULE_8__["default"], {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Header__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "ed-grid-main ".concat(utils_pageUtils__WEBPACK_IMPORTED_MODULE_13__/* .landingPageClasses */ .k0),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ErrorPage, {
                    statusCode: statusCode
                })
            })
        ]
    });
};
MyError.getInitialProps = function() {
    var _ref = _asyncToGenerator(_workspace_educative_yarn_virtual_next_virtual_1bd058a2ed_0_cache_next_patch_6b35a1a9ef_6d04a71070_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(props) {
        var ref, errorInitialProps, req, res, _isB2BDomain, ref1, ref2, ref3, extraErrorParams, extraTags;
        return _workspace_educative_yarn_virtual_next_virtual_1bd058a2ed_0_cache_next_patch_6b35a1a9ef_6d04a71070_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return next_error__WEBPACK_IMPORTED_MODULE_3__["default"].getInitialProps(props);
                case 3:
                    errorInitialProps = _ctx.sent;
                    req = props.req, res = props.res;
                    _isB2BDomain = (0,utils_environments__WEBPACK_IMPORTED_MODULE_11__/* .isB2BDomain */ .wD)({
                        serverRequest: req
                    });
                    if (!(((ref = props.res) === null || ref === void 0 ? void 0 : ref.statusCode) === 404)) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        statusCode: 404,
                        isB2BDomain: _isB2BDomain
                    });
                case 8:
                    if (props.err) {
                        ;
                        extraErrorParams = _defineProperty({}, constants_index__WEBPACK_IMPORTED_MODULE_9__/* .SENTRY_EVENT_EXTRA_PARAMS.pageBroken */ .jMz.pageBroken, "true");
                        extraTags = _defineProperty({}, constants_index__WEBPACK_IMPORTED_MODULE_9__/* .SENTRY_EVENT_EXTRA_PARAMS.pageBroken */ .jMz.pageBroken, "true");
                        if (req === null || req === void 0 ? void 0 : req.url) extraErrorParams[constants_index__WEBPACK_IMPORTED_MODULE_9__/* .SENTRY_EVENT_EXTRA_PARAMS.pageRoute */ .jMz.pageRoute] = ((ref1 = req.headers) === null || ref1 === void 0 ? void 0 : ref1["host"]) + req.url;
                        if (_isB2BDomain || (req === null || req === void 0 ? void 0 : (ref2 = req.headers) === null || ref2 === void 0 ? void 0 : (ref3 = ref2["cookie"]) === null || ref3 === void 0 ? void 0 : ref3.includes("enterprise_nav=true"))) {
                            extraErrorParams[constants_index__WEBPACK_IMPORTED_MODULE_9__/* .SENTRY_EVENT_EXTRA_PARAMS.b2bUser */ .jMz.b2bUser] = "true";
                            extraTags[constants_index__WEBPACK_IMPORTED_MODULE_9__/* .SENTRY_EVENT_EXTRA_PARAMS.b2bUser */ .jMz.b2bUser] = "true";
                        }
                        (0,utils_sentry__WEBPACK_IMPORTED_MODULE_12__/* .sendErrorEvent */ .uX)(props.err, extraErrorParams, {}, extraTags);
                    }
                    res === null || res === void 0 ? void 0 : res.setHeader("Cache-Control", "no-store");
                    return _ctx.abrupt("return", _objectSpreadProps(_objectSpread({
                        hasGetInitialPropsRun: true
                    }, errorInitialProps), {
                        isB2BDomain: _isB2BDomain
                    }));
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(props) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["default"] = (MyError);


/***/ }),

/***/ 18645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ek": function() { return /* binding */ productPageClasses; },
/* harmony export */   "Vl": function() { return /* binding */ lessonPageClasses; },
/* harmony export */   "k0": function() { return /* binding */ landingPageClasses; }
/* harmony export */ });
/* unused harmony export editorPageClasses */
var landingPageClasses = "landing-page tablet lg:desktop";
var productPageClasses = "product-page tablet lg:desktop";
var lessonPageClasses = "lesson-page tablet lg:desktop";
var editorPageClasses = "editor-page tablet lg:desktop";


/***/ })

}]);